import React from 'react';
import { FaCalendarAlt, FaCaretDown } from 'react-icons/fa';

/**
 * WhenButton — the "Go to date & time" trigger for playback time navigation.
 *
 * Replaces the old date/time chip whose icon was a magnifying glass (`FaSearch`) — a WRONG metaphor: the
 * control opens a month-grid calendar picker (WhenSheet), not a text search, so nothing signalled "this is
 * how you pull up footage at a time" (David 2026-08-07, #86bb7phhh). Now it wears a CALENDAR icon + the
 * current date + time (accent) + a ▾ caret so it reads as "tap to pick a date/time".
 *
 * Presentational: the parent owns the date/time strings + the onClick (which opens the shared WhenSheet).
 * Product-mode-clean — no backend calls here, so cloud/een reuse it unchanged (the picker's data still
 * flows through the parent's adapter-driven onRequestPresence/onSearch).
 *
 * `hero` = the full-width bottom-row treatment (the "Go to date & time" navigator); default = compact chip.
 * `year` (optional) renders as an inline sub-span of the date ("Aug 7" + ", 2026") so it can be CSS-hidden
 * where space is tight (the mobile bottom row shows "Aug 7 13:59"; tablet's hero shows the full year).
 */
const WhenButton = ({ date, time, year, onClick, hero = false, className = '' }) => (
  <button
    type="button"
    className={`mcpb-when-btn${hero ? ' mcpb-when-btn--hero' : ''}${className ? ` ${className}` : ''}`}
    onClick={onClick}
    aria-label="Go to date and time"
  >
    <FaCalendarAlt className="mcpb-when-btn__cal" aria-hidden="true" />
    <span className="mcpb-when-btn__dt">
      <span className="mcpb-when-btn__date">
        {date || '—'}
        {year ? <span className="mcpb-when-btn__year">, {year}</span> : null}
      </span>
      <span className="mcpb-when-btn__time">{time || '--:--'}</span>
    </span>
    <FaCaretDown className="mcpb-when-btn__car" aria-hidden="true" />
  </button>
);

export default WhenButton;
